export const GET_PLYRATINGS_STATED = "GET_PLYRATINGS_STATED";
export const GET_PLYRATINGS = "GET_PLYRATINGS";
export const GET_PLYRATINGS_ENDED = "GET_PLYRATINGS_ENDED";
export const ADD_PLYRATING_STATED = "ADD_PLYRATING_STARTED";
export const ADD_PLYRATING = "ADD_PLYRATING";
export const ADD_PLYRATING_ENDED = "ADD_PLYRATING_ENDED";
export const EDIT_PLYRATING_STATED = "EDIT_PLYRATING_STATED";
export const EDIT_PLYRATING = "EDIT_PLYRATING";
export const EDIT_PLYRATING_ENDED = "EDIT_PLYRATING_ENDED";
export const GET_PLYRATING = "GET_PLYRATING";
export const GET_PLYRATING_STATED = "GET_PLYRATING_STATED";
export const GET_PLYRATING_ENDED = "GET_PLYRATING_ENDED";
export const RESET_PLYRATING = "RESET_PLYRATING";
export const ERROR_PLYRATING = "ERROR_PLYRATING";
export const GET_ALL_PLYRATINGS_STATED = "GET_ALL_PLYRATINGS_STATED";
export const GET_ALL_PLYRATINGS = "GET_ALL_PLYRATINGS";
export const GET_ALL_PLYRATINGS_ENDED = "GET_ALL_PLYRATINGS_ENDED";
